import React, { useState, useEffect, useContext } from "react";
import { Container, Tab, Tabs, Row, Col, Card } from "react-bootstrap";
import DetailsView from "../../../Datasets/AllDataSets/Individual/IndividualDataTabs/DetailsOverview/DetailsView";
import Utilization from "../../../Datasets/AllDataSets/Individual/IndividualDataTabs/Utilization";
import ColumnsTable from "../../../Datasets/AllDataSets/Individual/IndividualDataTabs/ColumnsTab/ColumnsTable";
import Spinner from "../../../../utils/Spinner";
import DataLineage from "../../../DataLineage/DataLineage";
import { toast } from "react-toastify";
import axios from "axios";
// import {
//   DATABOOK_API,
//   TELEMETRY_API,
// } from "../../../../../constants/serverConfig";
import {
  DATABOOK_API,
  TELEMETRY_API,
} from "../../../../constants/serverConfig";

import moment from "moment";
import { useMsal } from "@azure/msal-react";
import { protectedResources } from "../../../../msalConfig";
import _ from "lodash";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
// import QualityTab from "./QualityTab";
import QualityTab from "../../../Datasets/AllDataSets/Individual/IndividualDataTabs/QualityTab";
import DatasetFieldsEditModel from "../../../Datasets/AllDataSets/Individual/IndividualDataTabs/DatasetFieldsEditModel";
import { AuthContext } from "../../../../AuthContext";
import PreviewTab from "../../../Datasets/AllDataSets/Individual/IndividualDataTabs/PreviewTab";
import DatasetColumns from "../../../Datasets/AllDataSets/Individual/IndividualDataTabs/DatasetColumns";
import { useParams } from "react-router-dom";
import { EXCLUDE_COLUMN } from "../../../../constants/Constant";
import MetricColumnsTable from "./MetricColumnsTable/MetricColumnsTable";

const IndividualMainTabMetricCatalog = (props) => {
  const { instance } = useMsal();
  const account = instance.getActiveAccount();
  const request = {
    scopes: protectedResources.graphMe.scopes,
    account: account,
  };
  const data = props.data;
  const modaldata = props.modal;
  const fetching = props.fetching;
  //for showing hide the data lineage tab
  const [hasLineage, setHasLineage] = useState(false);
  const [lineageData, setLineageData] = useState(null);
  //below usestate for handling the pending state of api and fetching tab
  const [isLoadingLineage, setIsLoadingLineage] = useState(true);
  const [lineageError, setLineageError] = useState(false);

  const [profilemtrTabStatus, setProfileMetrStatus] = useState(false);
  const [previewTabStatus, setPreviewTabStatus] = useState(false);
  // const [utilizationTabStatus, setUtilizationStatus] = useState(false);
  const [qualityMetrStatus, setQualityMetrStatus] = useState(false);
  const [qualdata, setqualData] = useState([]);
  const [qualfetching, setqualFetching] = useState(false);

  const [fieldname, setFieldName] = useState("");
  const { getToken, token, error } = useContext(AuthContext);
  const [datasetstage, setDatasetTags] = useState([]);
  const [securityclassification, setSecurityClassification] = useState([]);
  const [selectedfield, setSelectedField] = useState([]);
  const [sensitivity, setSensitivity] = useState([]);
  const [selectedclassification, setSelectedClassification] = useState([]);
  const [selectedsensitivity, setSelectedSensitivity] = useState([]);
  const [fieldDefaultValues, setFieldDefaultValues] = useState([]);
  const [sensitivityDefaultValues, setSensitivityDefaultValues] = useState([]);
  const [datasetOwner, setDatasetOwner] = useState([]);
  const [editDatasetOwnerFlag, setEditDatasetOwner] = useState(false);

  // const [utilizationfreqdata, setUtilizationFrequencyData] = useState([]);
  // const [utilizationUserdata, setUtilizationUserData] = useState([]);
  const [xaxisfrequencydata, setXaxisFrequencyData] = useState([]);
  const [yaxisuserdata, setXaxisUserData] = useState([]);
  const [xaxisLineardata, setXaxisLinearCountData] = useState([]);
  const [yaxisLinearuserdata, setYaxisLinearUserData] = useState([]);
  const [loadingpreview, setPreviewLoading] = useState([]);

  const [previewdata, setPreviewData] = useState([]);
  const [previewflag, setPreviewFlag] = useState(false);
  const [tableColumnsHeaders, setTableHeader] = useState([]);
  const [showPreviewBtn, setShowPreviewBtn] = useState(false);
  const [fetchingError, setFetchingError] = useState(false);

  const params = useParams();

  //not using this
  const showModal = (name) => {
    switch (name) {
      case "tags":
        setFieldDefaultValues(
          modaldata?.tags?.map((item) => ({
            label: item.tagName,
            value: item.fqn,
          }))
        );
        let tagselectedefault = [];
        modaldata?.tags?.map((item) => {
          tagselectedefault.push(
            ...datasetstage.filter((x) => x.value === item.fqn)
          );
        });
        setSelectedField(
          tagselectedefault.map((item) => ({
            tagName: item.label,
            fqn: item.value,
          }))
        );
        props.setModalFlag(true);
        setFieldName(name);
        break;
      case "securityClassification":
        setdefaultvalues();
        props.setModalFlag(true);
        setFieldName(name);
        break;

      case "sensitivity":
        setdefaultvalues();
        props.setModalFlag(true);
        setFieldName(name);
        break;

      case "owner":
        setEditDatasetOwner(true);
        setDatasetOwner(modaldata.owner);
        props.setModalFlag(true);
        setFieldName(name);
        break;

      default:
        break;
    }
  };

  // const closeModal = (flag) => {
  //   setSelectedClassification([]);
  //   setSelectedSensitivity([]);
  //   props.setModalFlag(flag);
  //   callapiwithtoken(getSelectSensitivity);
  // };

  const setdefaultvalues = () => {
    let classification = modaldata?.securityClassification;
    let defaultClassification = [];
    if (classification) {
      classification?.map((item) => {
        defaultClassification.push(
          ...securityclassification.filter((x) => x.value === item)
        );
      });
      setFieldDefaultValues(defaultClassification);
    }

    setSelectedField(classification);
    setSelectedClassification(defaultClassification?.map((item) => item.value));
    if (modaldata?.sensitivity?.length > 0) {
      var defaultselectedSensitivity = sensitivity?.filter(function (el) {
        return modaldata.sensitivity?.indexOf(el.value) >= 0;
      });
      setSelectedSensitivity(
        defaultselectedSensitivity?.map((item) => item.value)
      );
      setSensitivityDefaultValues(defaultselectedSensitivity);
    }
  };
  const sweetAlertHandler = (alert) => {
    const MySwal = withReactContent(Swal);

    MySwal.fire({
      title: alert.title,

      icon: alert.icon,

      footer: alert.footer,

      confirmButtonColor: "#0ca0ce",

      allowOutsideClick: false,
    });
  };

  const callapiwithtoken = async (callback) => {
    (async () => await getToken())();
    if (token) {
      await callback(token);
    }
    if (error) {
      try {
        const rtoken = (await instance.acquireTokenRedirect(request))
          .accessToken;
        await callback(rtoken);
      } catch (error) {
        console.log(error);
      }
    }
  };

  const getSecurityClassification = async (token) => {
    axios
      .get(
        `${DATABOOK_API}/glossary-classification/terms/classification/SecurityClassification`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((res) => {
        let result = res.data?.glossaryTerms.map((item) => {
          if (item.fqn !== null) {
            return { value: item.fqn, label: item.termName };
          }
        });
        setSecurityClassification(result);
      });
  };

  // const fetchAllTags = (token) => {
  //   axios
  //     .get(`${DATABOOK_API}/tag-classification/tags`, {
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: "Bearer " + token,
  //       },
  //     })
  //     .then((res) => {
  //       let result = res.data?.tags.map((item) => {
  //         if (item.fqn !== null) {
  //           return { value: item.fqn, label: item.tagName };
  //         }
  //       });
  //       setDatasetTags(result);
  //     });
  // };

  const fetchLineageData = async (token) => {
    setIsLoadingLineage(true);
    setLineageError(false);
    try {
      const res = await axios.get(
        `${DATABOOK_API}/lineage/datasets/${params.id}/Any/2`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      );
      if (res.status === 200) {
        setLineageData(res.data);
        setHasLineage(
          res.data.inbound.length > 0 || res.data.outbound.length > 0
        );
      } else {
        setHasLineage(false);
      }
    } catch (error) {
      console.error("Error fetching lineage data", error);
      setLineageError(true);
      setHasLineage(false);
    } finally {
      setIsLoadingLineage(false);
    }
  };

  useEffect(() => {
    const fetchdatasets = async () => {
      try {
        const token = (await instance.acquireTokenSilent(request)).accessToken;
        getqualitydata(token);
      } catch (error) {
        if (error) {
          try {
            const token = (await instance.acquireTokenRedirect(request))
              .accessToken;
            getqualitydata(token);
          } catch (error) {
            sweetAlertHandler({
              title: "Error while fetching the data. ",
              icon: "info",
            });
          }
        }
      }
    };
    fetchdatasets();
    // callapiwithtoken(fetchAllTags);
    // callapiwithtoken(getSecurityClassification);
    // callapiwithtoken(getSelectSensitivity);
    callapiwithtoken(fetchLineageData);
  }, [props.param, token]);
  // useEffect(() => {
  //   callapiwithtoken(fetchAllTags);
  //   callapiwithtoken(getSecurityClassification);
  //   callapiwithtoken(getSelectSensitivity);
  //   callapiwithtoken(fetchLineageData);
  // }, [modaldata]);

  const getSelectSensitivity = (token) => {
    try {
      const fetchCarouselPromises = modaldata.securityClassification?.map(
        (classification) =>
          axios.get(
            `${DATABOOK_API}/glossary-classification/terms/${classification}/terms`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token,
              },
            }
          )
      );

      if (fetchCarouselPromises) {
        Promise.all(fetchCarouselPromises).then((values) => {
          let container = [];
          values.map((res) => {
            res.data.glossaryTerms.map((item) =>
              container.push({ value: item.fqn, label: item.termName })
            );
          });
          setSensitivity(container);
        });
      }
    } catch (err) {
      console.log(err);
    }
  };

  const onChangeTab = (key) => {
    switch (key) {
      case "quality":
        // setQualityMetrStatus(true);
        setProfileMetrStatus(false);
        // setUtilizationStatus(false);
        setPreviewTabStatus(false);
        break;
      case "profilemetrics":
        setProfileMetrStatus(true);
        // setQualityMetrStatus(false);
        // setUtilizationStatus(false);
        setPreviewTabStatus(false);
        break;
      case "utilization":
        // setUtilizationStatus(true);
        // setQualityMetrStatus(false);
        setProfileMetrStatus(false);
        setPreviewTabStatus(false);
        break;
      case "preview":
        setPreviewTabStatus(false);
        // setQualityMetrStatus(false);
        // setUtilizationStatus(false);
        setProfileMetrStatus(false);
        break;

      default:
        setProfileMetrStatus(false);
        // setQualityMetrStatus(false);
        // setUtilizationStatus(false);
        setPreviewTabStatus(false);
        break;
    }
  };

  const getqualitydata = () => {
    const QUALITY_METRICS = `${TELEMETRY_API}metrics/quality/historical?dataset_name=${props.param}&metric_key=score&runs=10`;
    setqualFetching(true);
    axios.get(QUALITY_METRICS).then((res) => {
      let maindata = res.data;
      let filteriddata = _.filter(
        maindata["metrics"],
        (iddata) => iddata.datasetName === `${props.param}`
      );
      let qualdatas = [];
      _.map(filteriddata, (da) => {
        let unixupdatedate = moment.unix(da.batchDate);
        return qualdatas.push({
          datasetName: da.datasetName,
          metricValue: parseFloat(da.metricValue).toFixed(2),
          updatedAt: unixupdatedate.format("MMM D, YYYY"),
          metricclr: da.metricValue > 90 ? "HIGH" : "LOW",
        });
      });

      const today = new Date();
      const date = moment(today);
      let todaydate = date.format("MMM D, YYYY");

      let qualdataspecific = _.filter(
        qualdatas,
        (qu) => qu["updatedAt"] === todaydate
      );
      let parsedqualdata = _.map(qualdataspecific, "metricValue");
      let metriccolor = _.map(qualdataspecific, "metricclr");

      const { addQualityIdex } = props;
      let newobj = { bardata: parsedqualdata, metricclr: metriccolor };
      addQualityIdex({ qualityIndex: newobj });
      qualdatas.sort(
        (objA, objB) =>
          Number(new Date(objA.updatedAt)) - Number(new Date(objB.updatedAt))
      );
      setqualFetching(false);
      setqualData(qualdatas);
    });
  };

  // const validateEmptyField = () => {
  //   if (
  //     selectedclassification?.length === 0 ||
  //     selectedsensitivity?.length === 0
  //   ) {
  //     toast.info("Security classificaton or sensitivity cannot be blank. ", {
  //       position: "top-right",
  //       autoClose: 6000,
  //       hideProgressBar: false,
  //       closeOnClick: true,
  //       pauseOnHover: true,
  //       draggable: true,
  //       progress: undefined,
  //     });
  //     return true;
  //   }
  // };

  const validateFields = () => {
    return selectedclassification?.filter(
      (item) => item.indexOf("confidential") > -1
    );
  };

  // const editsaveDatasetFields = () => {
  //   if (fieldname === "securityClassification" || "sensitivity") {
  //     if (
  //       (validateFields()?.length > 0 && selectedsensitivity?.length === 0) ||
  //       (selectedclassification?.length === 0 &&
  //         selectedsensitivity?.length > 0)
  //     ) {
  //       toast.info("Security classificaton or sensitivity cannot be blank. ", {
  //         position: "top-right",
  //         autoClose: 6000,
  //         hideProgressBar: false,
  //         closeOnClick: true,
  //         pauseOnHover: true,
  //         draggable: true,
  //         progress: undefined,
  //       });
  //       return false;
  //     }
  //   }

  //   const inprogresstoast = toast.info(
  //     "Updating dataset fields. Please wait..."
  //   );
  //   let requestbody = "";
  //   if (fieldname === "owner") {
  //     requestbody = {
  //       id: modaldata?.fqn,
  //       owner: datasetOwner,
  //     };
  //   } else if (fieldname === "tags") {
  //     requestbody = {
  //       id: modaldata?.fqn,
  //       tags: selectedfield,
  //     };
  //   } else if (fieldname === "securityClassification" || "sensitivity") {
  //     requestbody = {
  //       id: modaldata?.fqn,
  //       securityClassification: selectedclassification,
  //       sensitivity: selectedsensitivity,
  //     };
  //   }
  //   axios
  //     .put(`${DATABOOK_API}/datasets`, requestbody, {
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: "Bearer " + token,
  //       },
  //     })
  //     .then((res) => {
  //       props.getallcolumndata(token);
  //       props.setModalFlag(false);
  //       toast.update(inprogresstoast, {
  //         render: "Dataset field updated successfully.",
  //         type: toast.TYPE.SUCCESS,
  //         autoClose: 6000,
  //         closeButton: true,
  //         isLoading: false,
  //       });
  //     })
  //     .catch((error) => {
  //       if (error.response.status == 401) {
  //         toast.update(inprogresstoast, {
  //           render: error.response.data,
  //           type: toast.TYPE.ERROR,
  //           autoClose: 6000,
  //           closeButton: true,
  //           isLoading: false,
  //         });
  //         closeModal();
  //       }
  //     });
  // };

  // const getSensitivityForClassification = (selectedSecurity) => {
  //   let allterms = [];

  //   selectedSecurity.map((classification) => {
  //     axios
  //       .get(
  //         `${DATABOOK_API}/glossary-classification/terms/${classification}/terms`,
  //         {
  //           headers: {
  //             "Content-Type": "application/json",
  //             Authorization: "Bearer " + token,
  //           },
  //         }
  //       )
  //       .then((res) => {
  //         allterms = [...allterms, ...res.data.glossaryTerms];
  //         let result = allterms.map((item) => {
  //           if (item.fqn !== null) {
  //             return { value: item.fqn, label: item.termName };
  //           }
  //         });
  //         setSelectedSensitivity([]);
  //         setSensitivity(result);
  //       });
  //   });
  // };
  // const editDatasetOwnerHandler = (e) => {
  //   let ownerlist = e.target.value.split(",");
  //   setDatasetOwner(ownerlist);
  // };

  // const getUserCountByDate = () => {
  //   axios
  //     .get(
  //       `${TELEMETRY_API}util/users/count/historical/datasetId?datasetId=${params.id}`
  //     )
  //     .then((res) => {
  //       const sortedDecending = [...res.data].sort(
  //         (dayfirst, daysecond) => Number(daysecond.day) - Number(dayfirst.day)
  //       );
  //       let xaxisdata = [];
  //       let yaxisdata = [];

  //       if (sortedDecending?.length > 6) {
  //         sortedDecending.slice(0, 6).map((item) => {
  //           item.count ? yaxisdata.push(item.count) : yaxisdata.push(null);
  //           item.day
  //             ? xaxisdata.push(convertMilisecondtoYYYYMMDD(item.day))
  //             : xaxisdata.push("");
  //           return item;
  //         });
  //       } else {
  //         sortedDecending?.forEach((element) => {
  //           element.count
  //             ? yaxisdata.push(element.count)
  //             : yaxisdata.push(null);
  //           element.day
  //             ? xaxisdata.push(convertMilisecondtoYYYYMMDD(element.day))
  //             : xaxisdata.push("");
  //         });
  //       }
  //       let finaldata = sortedDecending.map((item, index) => {
  //         return {
  //           slno: index + 1,
  //           count: item.count,
  //           day: convertMilisecondtoYYYYMMDD(item.day),
  //         };
  //       });
  //       setXaxisFrequencyData(xaxisdata);
  //       setXaxisUserData(yaxisdata);
  //       setUtilizationFrequencyData(finaldata);
  //     });
  // };

  // const getUtilizationUsersByDataset = () => {
  //   setLoading(true);
  //   axios
  //     .get(
  //       `${TELEMETRY_API}util/users/datasets/datasetId?datasetId=${params.id}`
  //     )
  //     .then((res) => {
  //       let xaxislineardata = [];
  //       let yaxislineardata = [];
  //       let userByDataset = res.data;

  //       if (userByDataset?.length > 6) {
  //         userByDataset.slice(0, 6).map((item) => {
  //           yaxislineardata.push(item.user);
  //           xaxislineardata.push(item.count);
  //           return item;
  //         });
  //       } else {
  //         userByDataset?.forEach((element) => {
  //           yaxislineardata.push(element.user);
  //           xaxislineardata.push(element.count);
  //         });
  //       }

  //       let lineardata = [...res.data].map((item, index) => {
  //         return {
  //           slno: index + 1,
  //           user: item.user,
  //           count: item.count,
  //         };
  //       });
  //       setXaxisLinearCountData(xaxislineardata);
  //       setYaxisLinearUserData(yaxislineardata);
  //       setUtilizationUserData(lineardata);
  //       setLoading(false);
  //     })
  //     .catch((error) => {
  //       setLoading(false);
  //     });
  // };

  // useEffect(() => {
  //   if (props.tabStatus) {
  //     // getUserCountByDate();
  //     // getUtilizationUsersByDataset();
  //   }
  // }, [params.id, props.tabStatus]);

  const convertMilisecondtoYYYYMMDD = (miliseconds) => {
    var date = new Date(miliseconds);
    var year = date.getFullYear();
    var month = ("0" + (date.getMonth() + 1)).slice(-2);
    var day = ("0" + date.getDate()).slice(-2);
    return year + "-" + month + "-" + day;
  };

  const getPreviewData = async (token) => {
    setPreviewLoading(true);
    axios
      .get(`${DATABOOK_API}/datasets/preview/datasets/${params.id}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        let keystoremove = [];
        let headercolumn = Object.keys(response?.data[0]);

        response.data?.forEach((column) => {
          for (const property in column) {
            if (
              isPlainObject(column[property]) ||
              Array.isArray(column[property])
            ) {
              keystoremove.push(property);
            }
          }
        });
        let toRemove = new Set(keystoremove);
        const tablecolumns = headercolumn.filter((x) => !toRemove.has(x));
        let maskedArray = [];

        const excludeColumn = props.maskedcolumns?.filter((x) => {
          return EXCLUDE_COLUMN.indexOf(x) < 0;
        });
        response.data?.forEach((item) => {
          let newobj = { ...item };

          excludeColumn?.forEach((column) => {
            newobj[column] = newobj[column]?.toString().replace(/[0-9]/g, "x");
          });
          maskedArray.push(newobj);
        });
        setPreviewData(maskedArray);
        setTableHeader(prepareTabledHeader(tablecolumns));
        setPreviewLoading(false);
        setShowPreviewBtn(true);
        setFetchingError(false);
      })
      .catch((error) => {
        setPreviewLoading(false);
        // toast.error(error?.response?.data, {
        //   position: "top-right",
        //   autoClose: 6000,
        //   hideProgressBar: false,
        //   closeOnClick: true,
        //   pauseOnHover: true,
        //   draggable: true,
        //   progress: undefined,
        // });
        setPreviewData([]);
        setTableHeader([]);
        setShowPreviewBtn(false);
        setFetchingError(true);
      });
  };

  useEffect(() => {
    let confidencialFlag = modaldata.securityClassification?.some(
      (confidencial) => confidencial?.indexOf("confidential") > -1
    );
    setPreviewFlag(confidencialFlag);
    setdefaultvalues();
    if (!confidencialFlag) {
      callapiwithtoken(getPreviewData);
    }
  }, [modaldata]);

  const isPlainObject = (o) => {
    return o === null ||
      Array.isArray(o) ||
      typeof o == "function" ||
      o.constructor === Date
      ? false
      : typeof o == "object";
  };
  const prepareTabledHeader = (columns) => {
    // let columns = Object.keys(data);
    let finalarray = [];
    if (columns.length > 0) {
      for (var i = 0; i < columns.length; i++) {
        if (Array.isArray(columns[i])) {
          break;
        }
        finalarray.push(columns[i]);
      }
      return finalarray.map((item) => {
        let columnheading = item.charAt(0).toUpperCase() + item.slice(1);
        return {
          Header: () => (
            <div className="column__table__header">
              {columnheading.toString()}
            </div>
          ),
          accessor: item.toString(),
          width: 200,
        };
      });
    }
  };

  return (
    <div style={{ border: "0px solid pink" }}>
      <Container className="py-3 container__width">
        <Tabs
          // defaultActiveKey="columns"
          className="tab__col"
          // onSelect={onChangeTab}
        >
          <Tab eventKey="dimensions" tabClassName="tabspecific" title="Dimensions">
            <Row className="w-1001">
              <Col>
                {fetching ? (
                  <div className="justify-content-md-center">
                    {" "}
                    <Spinner />
                  </div>
                ) : (
                  <>
                    <MetricColumnsTable
                      data={data}
                      getallcolumndata={props.getallcolumndata}
                      // editaccessflag={props.editaccessflag}
                      securityclassification={securityclassification}
                      sensitivity={sensitivity}
                      datasetstage={props.datasetstage}
                    />

                    {/* {data &&
                     <DatasetColumns data={data} securityclassification={securityclassification} sensitivity={sensitivity} />
                   } */}
                  </>
                )}
              </Col>
            </Row>
          </Tab>

          <Tab
            eventKey="lineage"
            title="Lineage"
            tabClassName="tabspecific"
          >
            {isLoadingLineage ? (
              <Spinner />
            ) : hasLineage && !lineageError ? (
              // <Tab
              //   eventKey="datalineage"
              //   title="Data Lineage"
              //   tabClassName="tabspecific"
              // >
              <Card className="tabs__card">
                <DataLineage
                  lineageData={lineageData}
                  fetchLineageData={fetchLineageData}
                />
              </Card>
            ) : (
              // </Tab>
              // <Tab
              //   eventKey="datalineage"
              //   title="Data Lineage"
              //   tabClassName="tabspecific"
              // >
              <Row>
                <div className="text-center p-5">
                  <span>No data Found.</span>
                </div>
              </Row>
              // </Tab>
            )}
          </Tab>

          {/* <Tab eventKey="preview" tabClassName="tabspecific" title="Preview">
            {previewflag ? (
              <Row>
                <div className="text-center p-5">
                  <span>
                    Preview cannot be viewed for confidencial dataset.
                  </span>
                </div>
              </Row>
            ) : loadingpreview ? (
              <div>
                {" "}
                <Spinner />
              </div>
            ) : previewdata?.length > 0 && !loadingpreview ? (
              <PreviewTab
                previewTabStatus={previewTabStatus}
                maskedcolumns={props.maskedcolumns}
                previewdata={previewdata}
                tableColumnsHeaders={tableColumnsHeaders}
                previewflag={previewflag}
                // loading={loadingpreview}
              />
            ) : (
              <Row>
                <div className="text-center p-5">
                  <span>No data Found.</span>
                </div>
              </Row>
            )}
            {/* {loadingpreview ? (
              <div>  <Spinner /></div>
            ) : (previewdata?.length > 0 && !loadingpreview) ? (
              <PreviewTab
                previewTabStatus={previewTabStatus}
                maskedcolumns={props.maskedcolumns}
                previewdata={previewdata}
                tableColumnsHeaders={tableColumnsHeaders}
                previewflag={previewflag}
              />
            ) : (
              <Row><div className="text-center p-5"><span>No data Found.</span></div></Row>
            )} 
            {showPreviewBtn && previewdata.length > 0 ? (
              <PreviewTab
                previewTabStatus={previewTabStatus}
                maskedcolumns={props.maskedcolumns}
                previewdata={previewdata}
                tableColumnsHeaders={tableColumnsHeaders}
              />
            ) : (
              <Row><div className="text-center p-5"><span>No data Found.</span></div></Row>
            )} 
          </Tab> */}
          {/* <Tab
            eventKey="confidence"
            tabClassName="tabspecific"
            title="Confidence"
          >
            {qualfetching ? (
              <Spinner />
            ) : qualdata.length > 0 && !qualfetching ? (
              <QualityTab
                qualityTabStatus={qualityMetrStatus}
                tablequalitytable={qualdata}
                tablequalitygraph={qualdata}
                fetching={qualfetching}
              />
            ) : (
              <Row>
                <div className="text-center p-5">
                  <span>No data Found.</span>
                </div>
              </Row>
            )}
          </Tab>  */}
        </Tabs>
        
        {/* <DatasetFieldsEditModel
          show={props.show}
          name={fieldname}
          datasetstage={datasetstage}
          detaildata={modaldata}
          setSelectedField={setSelectedField}
          editsaveDatasetFields={editsaveDatasetFields}
          fieldDefaultValues={fieldDefaultValues}
          securityclassification={securityclassification}
          setSelectedClassification={setSelectedClassification}
          getSensitivityForClassification={getSensitivityForClassification}
          sensitivity={sensitivity}
          setSelectedSensitivity={setSelectedSensitivity}
          selectedsensitivity={selectedsensitivity}
          sensitivityDefaultValues={sensitivityDefaultValues}
          closeModel={closeModal}
          editDatasetOwnerFlag={editDatasetOwnerFlag}
          datasetOwner={datasetOwner}
          editDatasetOwnerHandler={editDatasetOwnerHandler}
        /> */}
      </Container> 
    </div>
  );
};

export default IndividualMainTabMetricCatalog;
